import { ReactElement, useState } from 'react'
import {
  TableWrapper,
  TableHeader,
  PageWrapper,
  SectionTitle
} from '../../../../components'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { TableRow } from './subcomponents'
import strings from '../../../../locale/en'
import Button from 'react-bootstrap/Button'
import Approve from './Approve'
import Reject from './Reject'

const PendingRequests = (): ReactElement => {
  const [isApprove, setIsApprove] = useState(false)
  const [isReject, setIsReject] = useState(false)
  const {
    menu: {
      admin: {
        createTest: { pendingRequests }
      }
    },
    button: { approve, reject }
  } = strings
  return (
    <PageWrapper id="container">
      <SectionTitle title={pendingRequests} />
      <TableWrapper>
        <Table size="sm" responsive="sm">
          <TableHeader>
            <TableRow>
              {tableHeader?.map((header, index) => (
                <th key={`test-listing-header-${index}`}>{header}</th>
              ))}
            </TableRow>
          </TableHeader>
          <tbody>
            <td>{'Test type'}</td>
            <td>{'Student name'}</td>
            <td>{'PENDING'}</td>
            <td>{'180.0'}</td>
            <td>
              <Button variant="link" active onClick={() => setIsApprove(true)}>
                {approve}
              </Button>
            </td>
            <td>
              <Button variant="link" active onClick={() => setIsReject(true)}>
                {reject}
              </Button>
            </td>
          </tbody>
        </Table>
      </TableWrapper>
      {isApprove && (
        <Approve
          handleSubmit={() => setIsApprove(false)}
          handleCancel={() => setIsApprove(false)}
        />
      )}
      {isReject && (
        <Reject
          handleSubmit={() => setIsReject(false)}
          handleCancel={() => setIsReject(false)}
        />
      )}
    </PageWrapper>
  )
}

export default PendingRequests
